import React from 'react';
import styled from 'styled-components';
import { withTheme } from '@material-ui/core';
import { palette } from 'theme';
import Avatar from '@material-ui/core/Avatar';

const StyledAvatar = ({ theme, ...props }) => (
  <GradientAvatar theme={theme} {...props} />
);

const GradientAvatar = styled(Avatar)`
  width: ${props => (props.size ? props.size : '100px')};
  height: ${props => (props.size ? props.size : '100px')};
  padding: 4px;
  background: ${props =>
    `linear-gradient(${props.theme.brand.gradient.primary})`};
  position: relative;
  &:after {
    content: '';
    display: block;
    background: ${palette.grey[900]};
    position: absolute;
    left: 4px;
    right: 4px;
    bottom: 4px;
    top: 4px;
    border-radius: 50%;
    z-index: 0;
  }
  img {
    position: relative;
    z-index: 1;
    border-radius: 50%;
  }
  svg {
    z-index: 1;
    position: relative;
    width: 48px;
    height: 48px;
    opacity: 0.5;
  }
`;

export default withTheme()(StyledAvatar);
